/**
 * A SENTENCE OPS PRINTS WITH THE OFFICE'S NUMBER IN IT, drawn word for word with the number as a
 * link that calls it (`Phone.tsx`): ops's section 12.5 writes "Call or text the office at (727)
 * 337-7775." and "... at (727) 337-7775 to change it.", and a phone on these screens is always a
 * link. The words before the number, the number, and the words after it read exactly as ops wrote
 * them; a sentence with no number in it is drawn as it is.
 */
import { PHONE_SHOWN } from '../contact.ts';
import { Phone } from './Phone.tsx';

export function SaidWithPhone({ words }: { readonly words: string }) {
  const at = words.indexOf(PHONE_SHOWN);
  if (at < 0) return <>{words}</>;
  const before = words.slice(0, at);
  const after = words.slice(at + PHONE_SHOWN.length);
  if (after === '.') {
    return (
      <>
        {before}
        <Phone after="." />
      </>
    );
  }
  // What follows the number starts with a space, so the line may break before it, and it is drawn
  // after one, as the sentence has it.
  return (
    <>
      {before}
      <Phone /> {after.trimStart()}
    </>
  );
}
